import type {} from '@tanstack/react-query';

import { _activateRevision } from './ActivateRevision';
import { _checkRevisionCompatibility } from './CheckRevisionCompatibility';
import { _create } from './Create';
import { _createRevision } from './CreateRevision';
import { _delete } from './Delete';
import { _get } from './Get';
import { _list } from './List';
import { _listRevisions } from './ListRevisions';
import { _update } from './Update';

export namespace useImportTableDefinition {
  export const Get: typeof _get = _get;
  export const List: typeof _list = _list;
  export const Create: typeof _create = _create;
  export const Update: typeof _update = _update;
  export const Delete: typeof _delete = _delete;
  export const ListRevisions: typeof _listRevisions = _listRevisions;
  export const CreateRevision: typeof _createRevision = _createRevision;
  export const CheckRevisionCompatibility: typeof _checkRevisionCompatibility = _checkRevisionCompatibility;
  export const ActivateRevision: typeof _activateRevision = _activateRevision;
}
export { importTableDefinitionQueryKeys } from './queryKeys';
